import {useContext} from "react";
import {ClientHierarchySearchState} from "./ClientHierarchySearchState";
import {ClientHierarchySearchStateContext} from "./ClientHierarchySearchStateProvider";

export function useClientHierarchySearchState(): ClientHierarchySearchState {
  return useContext(ClientHierarchySearchStateContext);
}
